var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":"","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('tbl-project-route',{attrs:{"project":_vm.project}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }